(() => {
  const slider = document.querySelector('[data-home-slider]');
  if (!slider) return;

  const slides = [...slider.querySelectorAll('[data-hero-slide]')];
  const dots = [...slider.querySelectorAll('[data-slide-to]')];
  const title = slider.querySelector('[data-hero-title]');
  const eyebrow = slider.querySelector('[data-hero-eyebrow]');
  const description = slider.querySelector('[data-hero-description]');
  const productTitle = slider.querySelector('[data-hero-product-title]');
  const price = slider.querySelector('[data-hero-price]');
  const productLink = slider.querySelector('[data-hero-product-link]');
  const collectionLink = slider.querySelector('[data-hero-collection-link]');
  const collectionLabel = slider.querySelector('[data-hero-collection-label]');
  const progress = slider.querySelector('[data-slide-progress]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const autoplayDelay = 6500;
  let activeIndex = 0;
  let autoplayTimer;
  let paused = false;

  const resetProgress = () => {
    window.clearTimeout(autoplayTimer);
    if (!progress) return;
    progress.style.animation = 'none';
    progress.style.transform = 'scaleX(0)';
    if (reducedMotion.matches) return;
    void progress.offsetWidth;
    progress.style.animation = `rdr21-progress ${autoplayDelay}ms linear forwards`;
    progress.style.animationPlayState = paused ? 'paused' : 'running';
  };

  const scheduleNext = () => {
    window.clearTimeout(autoplayTimer);
    if (paused || reducedMotion.matches || slides.length < 2) return;
    autoplayTimer = window.setTimeout(() => showSlide(activeIndex + 1), autoplayDelay);
  };

  const pause = () => {
    paused = true;
    window.clearTimeout(autoplayTimer);
    if (progress) progress.style.animationPlayState = 'paused';
  };

  const resume = () => {
    if (!paused) return;
    paused = false;
    resetProgress();
    scheduleNext();
  };

  const showSlide = (nextIndex) => {
    activeIndex = (nextIndex + slides.length) % slides.length;
    const activeSlide = slides[activeIndex];
    if (!activeSlide) return;

    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.hidden = !isActive;
      slide.classList.toggle('is-active', isActive);
    });
    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      if (isActive) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });

    eyebrow.textContent = activeSlide.dataset.eyebrow || '';
    title.textContent = activeSlide.dataset.title || '';
    description.textContent = activeSlide.dataset.description || '';
    productTitle.textContent = activeSlide.dataset.productTitle || '';
    price.textContent = activeSlide.dataset.price || '';
    productLink.href = activeSlide.dataset.productUrl || activeSlide.dataset.collectionUrl || '/collections/all';
    collectionLink.href = activeSlide.dataset.collectionUrl || '/collections/all';
    if (collectionLabel) collectionLabel.textContent = activeSlide.dataset.collectionLabel || '';
    resetProgress();
    scheduleNext();
  };

  slider.querySelector('[data-slide-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
  slider.querySelector('[data-slide-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
  dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.slideTo))));
  slider.addEventListener('pointerenter', pause);
  slider.addEventListener('pointerleave', resume);
  slider.addEventListener('focusin', pause);
  slider.addEventListener('focusout', (event) => {
    if (!slider.contains(event.relatedTarget)) resume();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) pause();
    else resume();
  });
  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) pause();
    else resume();
  });
  resetProgress();
  scheduleNext();
})();
